import { render, staticRenderFns } from "./RefundTransDetails.vue?vue&type=template&id=b7dc7a08&scoped=true"
import script from "./RefundTransDetails.vue?vue&type=script&lang=js"
export * from "./RefundTransDetails.vue?vue&type=script&lang=js"
import style0 from "./RefundTransDetails.vue?vue&type=style&index=0&id=b7dc7a08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc7a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7dc7a08')) {
      api.createRecord('b7dc7a08', component.options)
    } else {
      api.reload('b7dc7a08', component.options)
    }
    module.hot.accept("./RefundTransDetails.vue?vue&type=template&id=b7dc7a08&scoped=true", function () {
      api.rerender('b7dc7a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/RefundTransDetails.vue"
export default component.exports